<div class="building-scan-detail-page">
  <wr-full-screen-panel [buttons]="false">
    <nb-card>
      <nb-card-header>
        <h5>Gebäudescan</h5>
        <wr-full-screen-button></wr-full-screen-button>
      </nb-card-header>
      <nb-card-body>
        <div class="iframe-wrapper">
          @if(buildingScanLink() !== null) {
            <iframe [src]="buildingScanLink()"
                    scrolling="no"
                    frameborder="0"
                    allowfullscreen>
            </iframe>
          }
        </div>
      </nb-card-body>
    </nb-card>
  </wr-full-screen-panel>
</div>
